import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {
  isImageElement,
  isTypographic,
  isFormSelect,
  isFormTextarea,
  isFormReCaptcha,
  isDynamoWrapper,
  isDynamoList,
  isSearchResultWrapper,
  isSearchResultList,
  isUserAccountSubscriptionListWrapper,
  isUserAccountSubscriptionList,
  isCommerceAddToCartWrapper,
  isEmbed,
  isWidget,
  isSliderNav,
} from '@packages/utilities/elementTypeUtils';
import {
  isComponentInst,
  getComponentInstRootElement,
} from '@packages/utilities/platform';
import {selectedElementContainsSlot} from './selectedElementContainsSlot';
import {Component} from '@packages/systems/wfdl';

export function isStandard(
  element: ExpressionElement,
  componentMap: Component.ComponentMap
): boolean {
  if (isImageElement(element)) {
    return false;
  }

  if (isTypographic(element)) {
    return false;
  }

  if (isFormSelect(element)) {
    return false;
  }
  if (isFormTextarea(element)) {
    return false;
  }
  if (isFormReCaptcha(element)) {
    return false;
  }

  // Component instances are not editable, elements must be added to the component root instead
  if (isComponentInst(componentMap)(element)) {
    const root = getComponentInstRootElement(componentMap)(element);
    return (root && selectedElementContainsSlot(root)) || false;
  }

  // Certain holder elements have managed children nodes
  if (isDynamoWrapper(element)) {
    return false;
  }
  if (isDynamoList(element)) {
    return false;
  }
  if (isSearchResultWrapper(element)) {
    return false;
  }
  if (isSearchResultList(element)) {
    return false;
  }
  if (isUserAccountSubscriptionListWrapper(element)) {
    return false;
  }
  if (isUserAccountSubscriptionList(element)) {
    return false;
  }
  if (isCommerceAddToCartWrapper(element)) {
    return false;
  }

  // Embeds and widgets (maps, facebook, Twitter etc) can never take children
  if (isEmbed(element)) {
    return false;
  }

  if (isWidget(element)) {
    return false;
  }

  // Slider nav wrapper currently cannot take children (they're auto generated)
  if (isSliderNav(element)) {
    return false;
  }

  return true;
}
